// extracted by mini-css-extract-plugin
module.exports = {"sliderItem":"B9cl","slideContent":"B9lp","imageWrapper":"B9lr","img":"B9lt","content":"B9bd","title":"B9al","description":"B9lv","date":"B9g7","advMarker":"B9lx"};